<template>
  <div>
    <el-radio-group style="margin:10px 0 0 10px" v-model="activeName" size="mini">
      <el-radio-button v-permission="'manage_menu_adv_order'" label="order" name="order">
        普通订单
      </el-radio-button>
      <el-radio-button v-permission="'view_the_puke_order'" label="regular" name="regular">
        普客打包
      </el-radio-button>
      <el-radio-button v-permission="'view_the_wcm_order'" label="project" name="project">
        全案营销
      </el-radio-button>
      <el-radio-button v-permission="'view_the_wcm_order'" label="project_2" name="project_2">
        年框大全案
      </el-radio-button>
      <el-radio-button v-permission="'manage_menu_adv_order'" label="pure_live" name="pure_live">
        纯直播
      </el-radio-button>
    </el-radio-group>
    <!--    各个tab-->
    <order-index :pt="PT.PT" v-if="activeName==='order'"></order-index>
    <order-regular :cooperation="`普客打包`" :pt="PT.PK" v-if="activeName==='regular'"></order-regular>
    <order-project key="红人全案" :cooperation="`红人全案`" :pt="PT.QA" v-if="activeName==='project'"></order-project>
    <order-project key="年框大全案" :cooperation="`年框大全案`" :pt="PT.NK" v-if="activeName==='project_2'"></order-project>
    <order-index :pt="PT.CZB" v-if="activeName==='pure_live'" key="pure_live" pure-live/>
  </div>
</template>

<script>
import orderIndex from '@/views/adOrder/order/Index.vue'
import orderRegular from '@/views/adOrder/regular/Index.vue'
import orderProject from '@/views/adOrder/project/Index.vue'

const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}
const {manage_menu_adv_order, view_the_puke_order, view_the_wcm_order} = permissions
let activeName
if (manage_menu_adv_order) {
  activeName = 'order'
} else if (view_the_puke_order) {
  activeName = 'regular'
} else if (view_the_wcm_order) {
  activeName = 'project'
}

export default {
  name: "index",
  data() {
    return {
      activeName,
      PT: {
        PT: 1, // 普通订单
        QA: 2, // 全案营销
        PK: 3, // 普客打包
        NK: 4, // 年框大全案
        CZB: 5, // 纯直播
      }
    }
  },
  components: {
    orderIndex,
    orderRegular,
    orderProject
  }
}
</script>

<style scoped>

</style>
